import { S3Client } from '@aws-sdk/client-s3';
import { Upload } from '@aws-sdk/lib-storage';

const s3Client = new S3Client({
    region: 'us-east-1',
    credentials: {
        accessKeyId: "AKIAFBC97UM4I3ILWTIKQ",
        secretAccessKey: "vMUNWcZvMesuFfmUwdUYnsaOr1pp38wu8nOon8eb",
    },
    endpoint: "https://s3-noi.aces3.ai/",
    forcePathStyle: true,
    requestChecksumCalculation: "WHEN_REQUIRED",
    responseChecksumValidation: "WHEN_REQUIRED",
});

export const uploadFileToS3 = async (file, path = "salla_chat/uploads/") => {
    console.log(file, "filefilefile")
    // const key = `${path}${Date.now()}_${file.name}`;
    const key = `${path}${Date.now()}_${file.name}`;

    const contentType = file.type || 'application/octet-stream'; // Fallback to default
    const upload = new Upload({
        client: s3Client,
        // params: {
        //     Bucket: 'invent-co-new',
        //     Key: key,
        //     Body: file,
        // },
        params: {
            Bucket: 'invent-co-new',
            Key: key,
            Body: file,
            ContentType: contentType, // ✅ Set correct content-type
            ACL: 'public-read',       // ✅ Ensure it's accessible
        },
    });

    const data = await upload.done();
    console.log(data, "data")
    return data.Location; // Public S3 file URL
};